import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Table} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formataDataHoraExibicao, localUso } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaCheck } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import Paginacao from '../../common/pagination';

class InventarioEdit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inventario_id: "",
            tipo_equipamento_id: "",
            tipo_equipamento_nome: "",
            numero_patrimonio: "",
            especificacao: "",
            descricao: "",
            colaborador_id: "",
            colaborador_nome: "",
            local_uso: "",
            projeto_id: "",
            projeto_nome: "",
            data_entrega: "",
            
            titulo_pagina: "",
            loading: false,
            erroLoadRegistro: "",
            numeroPatrimonioHelper: "",
            especificacaoHelper: "",
            tipoEquipamentoHelper: "",
            logs_inventario: { results: [], count: 0 },
            logs_loading: false,
            logs_error: "",
            logs_page_numb: 1,
            logs_carregados: false,
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;

        if (id) {
            this.setState({
                inventario_id: id,
                titulo_pagina: 'Editando Equipamento',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/inventario/equipamentos/${id}/`)
                .then(response => {
                    const dados = response.data;

                    this.setState({
                        erroLoadRegistro: '',
                        numero_patrimonio: dados.numero_patrimonio || '',
                        especificacao: dados.especificacao || '',
                        descricao: dados.descricao || '',
                        tipo_equipamento_id: dados.tipo_equipamento_id || '',
                        tipo_equipamento_nome: dados.dados_tipo_equipamento?.nome || '',
                        colaborador_id: dados.colaborador_id || '',
                        colaborador_nome: dados.dados_colaborador?.nome || '',
                        projeto_id: dados.projeto_id || '',
                        projeto_nome: dados.dados_projeto?.nome || '',
                        data_entrega: dados.data_entrega || '',
                        local_uso: dados.local_uso || '',
                        loading: false
                    });
                })
                .catch(error => {
                    let erro_msg = 'Erro ao consultar equipamento, tente novamente';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                inventario_id: '',
                titulo_pagina: 'Adicionar Equipamento',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            numeroPatrimonioHelper: "",
            especificacaoHelper: "",
            tipoEquipamentoHelper: ""
        });

        const url = this.state.inventario_id ? `/inventario/equipamentos/${this.state.inventario_id}/` : '/inventario/equipamentos/';
        const metodo = this.state.inventario_id ? 'put' : 'post';

        const payload = {
            tipo_equipamento_id: this.state.tipo_equipamento_id,
            numero_patrimonio: this.state.numero_patrimonio,
            especificacao: this.state.especificacao,
            descricao: this.state.descricao,
            local_uso: this.state.local_uso || null,
            colaborador_id: this.state.colaborador_id || null,
            projeto_id: this.state.projeto_id || null,
            data_entrega: this.state.data_entrega || null,
        };

        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            const textSwal = this.state.inventario_id ? 'Equipamento atualizado com sucesso' : 'Equipamento cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({
                loading: false,
                logs_carregados: false
            });

            if (!this.state.inventario_id) {
                this.props.router.navigate("/inventario");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao salvar o equipamento, verifique os campos e tente novamente';

            this.setState({
                numeroPatrimonioHelper: "",
                especificacaoHelper: "",
                tipoEquipamentoHelper: ""
            });

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                const mensagensErro = [];

                for (let key in campos) {
                    const value = Array.isArray(campos[key]) ? campos[key][0] : campos[key];

                    if (key === 'numero_patrimonio') {
                        this.setState({ numeroPatrimonioHelper: value });
                    } else if (key === 'especificacao') {
                        this.setState({ especificacaoHelper: value });
                    } else if (key === 'tipo_equipamento_id') {
                        this.setState({ tipoEquipamentoHelper: value });
                    }

                    if (typeof value === 'string') {
                        mensagensErro.push(value);
                    }
                }

                if (mensagensErro.length > 0) {
                    erro_msg = mensagensErro.join('\n');
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Erro ao salvar o equipamento',
                text: erro_msg,
            });

            this.setState({ loading: false });
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleChangeTipoEquipamento = (selectedOption) => {
        this.setState({
            tipo_equipamento_id: selectedOption?.value || '',
            tipo_equipamento_nome: selectedOption?.label || '',
        });
    };

    handleChangeColaborador = (selectedOption) => {
        this.setState({
            colaborador_id: selectedOption?.value || '',
            colaborador_nome: selectedOption?.label || '',
        });
    };

    handleChangeProjeto = (selectedOption) => {
        this.setState({
            projeto_id: selectedOption?.value || '',
            projeto_nome: selectedOption?.label || '',
        });
    };

    handleSelectTab = (aba) => {
        if (aba === 'logsInventario' && this.state.inventario_id && !this.state.logs_carregados) {
            this.getLogsInventario();
        }
    };

    getLogsInventario = (page_numb = 1) => {
        if (!this.state.inventario_id) return;

        this.setState({
            logs_loading: true,
            logs_error: "",
            logs_page_numb: page_numb,
        });

        api.get(`/inventario/equipamentos/${this.state.inventario_id}/logs/?page=${page_numb}`)
            .then(response => {
                const dados = Array.isArray(response.data)
                    ? { results: response.data, count: response.data.length }
                    : response.data;

                this.setState({
                    logs_inventario: dados || { results: [], count: 0 },
                    logs_loading: false,
                    logs_error: "",
                    logs_carregados: true,
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar logs do inventário, tente novamente.';

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response?.status === 403) {
                    erro_msg = 'Você não tem permissão para visualizar os logs deste equipamento.';
                } else if (error.response?.status === 404) {
                    erro_msg = 'Equipamento não encontrado.';
                }

                this.setState({
                    logs_loading: false,
                    logs_error: erro_msg,
                });
            });
    };

    logsOnClickPagina = (num_page) => {
        this.getLogsInventario(num_page);
    };

    formatarDataHoraLog = (data) => {
        if (!data) return '';

        const dataPossuiFuso = /(Z|[+-]\d{2}:\d{2})$/i.test(data);

        if (!dataPossuiFuso) {
            return formataDataHoraExibicao(data);
        }

        const dataObj = new Date(data);

        if (Number.isNaN(dataObj.getTime())) {
            return data;
        }

        return dataObj.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }) + 'h';
    };

    formatarAcaoLog = (actionFlag) => {
        const acoes = {
            1: 'Adicionado',
            2: 'Alterado',
            3: 'Excluído',
        };

        return acoes[actionFlag] || actionFlag || '-';
    };

    renderDescricaoLog = (item) => {
        const descricao = item.change_message || item.object_repr || '-';

        return (
            <span style={{ whiteSpace: 'pre-line' }}>
                {descricao}
            </span>
        );
    };

    renderRowsLogsInventario = () => {
        const logs = this.state.logs_inventario?.results || [];

        if (logs.length > 0) {
            return logs.map((item, index) => (
                <tr key={item.id || `${item.action_time}-${item.object_id}-${index}`}>
                    <td>{this.formatarDataHoraLog(item.action_time)}</td>
                    <td>{this.renderDescricaoLog(item)}</td>
                    <td>{this.formatarAcaoLog(item.action_flag)}</td>
                    <td>{[item.user__first_name, item.user__last_name].filter(Boolean).join(' ') || '-'}</td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={4}>Nenhum log encontrado</td>
            </tr>
        );
    };

    carregaTipoEquipamento = async (inputValue) => {
        try {
            const response = await api.get(`/inventario/tipos/?nome=${inputValue}`);
            const dados = response.data.results || response.data;
            
            const opcoes = dados.map(tipo => ({
                value: tipo.id,
                label: tipo.nome
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar tipos de equipamento:', error);
            return [];
        }
    };

    carregarUsuariosFuncionarios = async (inputValue) => {
        const q = inputValue ? `&nome=${encodeURIComponent(inputValue)}` : "";
        
        try {
            const response = await api.get(`/usuarios/?page=1&funcionario=True${q}`);
            
            const results = Array.isArray(response.data?.results)
                ? response.data.results
                : (Array.isArray(response.data) ? response.data : []);

            const opcoes = results.map(u => {
                const first = (u.first_name || "").trim();
                const last = (u.last_name || "").trim();
                const email = (u.email || "").trim();
                const displayName = [first, last].filter(Boolean).join(" ").trim();

                let label = "";
                if (displayName && email) label = `${displayName} (${email})`;
                else if (displayName) label = displayName;
                else label = email;

                return { value: u.id, label };
            });

            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar colaboradores:', error);
            return [];
        }
    };

    carregarProjetos = async (inputValue) => {
        const q = inputValue ? `nome=${encodeURIComponent(inputValue)}` : "";
        
        try {
            const response = await api.get(`/inventario/projetos/?${q}`);
            const dados = response.data.results || response.data;
            const opcoes = dados.map(projeto => ({
                value: projeto.id,
                label: projeto.nome
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar projetos:', error);
            return [];
        }
    };

    render() {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
        };

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosInventario" id="tabs-inventario" className="aditus-tabs" onSelect={this.handleSelectTab}>
                    <Tab eventKey="dadosInventario" title="Dados do Equipamento">
                        <Card className="cardDestaque">
                            <Card.Body>
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Equipamento</h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Número do Patrimônio <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    required
                                                    type="number"
                                                    min="1"
                                                    name="numero_patrimonio"
                                                    placeholder="Ex: 5"
                                                    value={this.state.numero_patrimonio}
                                                    onChange={this.handleChange}
                                                />
                                                <Form.Text className="text-danger">{this.state.numeroPatrimonioHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo de Equipamento <span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregaTipoEquipamento}
                                                    defaultOptions
                                                    name="tipo_equipamento_id"
                                                    placeholder="Buscar tipo de equipamento..."
                                                    noOptionsMessage={() => "Nenhum tipo encontrado"}
                                                    onChange={this.handleChangeTipoEquipamento}
                                                    value={this.state.tipo_equipamento_id ? {value: this.state.tipo_equipamento_id, label: this.state.tipo_equipamento_nome} : null}
                                                    styles={customStyles}
                                                />
                                                <Form.Text className="text-danger">{this.state.tipoEquipamentoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Especificação do Equipamento <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    required
                                                    type="text" 
                                                    name="especificacao" 
                                                    placeholder="Ex: Dell Inspiron 15, i7, 16GB RAM" 
                                                    value={this.state.especificacao} 
                                                    onChange={this.handleChange} 
                                                />
                                                <Form.Text className="text-danger">{this.state.especificacaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="fw-semibold d-flex align-items-center gap-2">
                                                    <FiUser className="text-muted" /> Colaborador
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={this.carregarUsuariosFuncionarios}
                                                    placeholder="Selecione o colaborador"
                                                    noOptionsMessage={() => "Nenhum colaborador encontrado"}
                                                    onChange={this.handleChangeColaborador}
                                                    value={this.state.colaborador_id ? {value: this.state.colaborador_id, label: this.state.colaborador_nome} : null}
                                                    isClearable
                                                    styles={customStyles}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Local de Uso</Form.Label>
                                                <Form.Control 
                                                    as="select" 
                                                    name="local_uso" 
                                                    value={this.state.local_uso} 
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Selecione...</option>
                                                    {Object.entries(localUso).map(([chave, valor]) => (
                                                        <option key={chave} value={chave}>{valor}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data de Entrega</Form.Label>
                                                <Form.Control 
                                                    type="date" 
                                                    name="data_entrega" 
                                                    value={this.state.data_entrega} 
                                                    onChange={this.handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Projeto</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={this.carregarProjetos}
                                                    placeholder="Selecione o projeto"
                                                    noOptionsMessage={() => "Nenhum projeto encontrado"}
                                                    onChange={this.handleChangeProjeto}
                                                    value={this.state.projeto_id ? { value: this.state.projeto_id, label: this.state.projeto_nome} : null}
                                                    isClearable
                                                    styles={customStyles}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição / Observações</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="descricao"
                                                    value={this.state.descricao}
                                                    onChange={this.handleChange}
                                                    placeholder="Informações adicionais sobre o equipamento..."
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {this.state.erroLoadRegistro && 
                                        <Alert variant="warning">
                                            {this.state.erroLoadRegistro}
                                        </Alert>
                                    }

                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar Equipamento
                                            </>
                                        )}
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Tab>
                    <Tab eventKey="logsInventario" title="Logs">
                        <Card className="cardDestaque">
                            <Card.Body>
                                <h4><strong>Logs do inventário:</strong></h4>

                                {!this.state.inventario_id ? (
                                    <Alert variant="info" className="mt-3">
                                        Salve o equipamento para visualizar os logs.
                                    </Alert>
                                ) : (
                                    <>
                                        <Table responsive className="custom-table mt-3">
                                            <thead>
                                                <tr>
                                                    <th>Data</th>
                                                    <th>Descrição</th>
                                                    <th>Ação</th>
                                                    <th>Usuário</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.logs_loading ? (
                                                    <tr>
                                                        <td colSpan={4}>Carregando...</td>
                                                    </tr>
                                                ) : (
                                                    this.state.logs_error ? (
                                                        <tr>
                                                            <td colSpan={4}>
                                                                <Alert variant="warning" className="mb-0">
                                                                    {this.state.logs_error}
                                                                    <div className="mt-2">
                                                                        <Button
                                                                            type="button"
                                                                            variant="outline-secondary"
                                                                            size="sm"
                                                                            onClick={() => this.getLogsInventario(this.state.logs_page_numb)}
                                                                        >
                                                                            Tentar novamente
                                                                        </Button>
                                                                    </div>
                                                                </Alert>
                                                            </td>
                                                        </tr>
                                                    ) : this.renderRowsLogsInventario()
                                                )}
                                            </tbody>
                                        </Table>

                                        {'results' in this.state.logs_inventario && this.state.logs_inventario.results.length > 0 &&
                                            <Paginacao
                                                dados={this.state.logs_inventario}
                                                loading={this.state.logs_loading}
                                                page_numb={this.state.logs_page_numb}
                                                _onClickPagina={this.logsOnClickPagina}
                                            />
                                        }
                                    </>
                                )}
                            </Card.Body>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default withRouter(InventarioEdit);
